import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QuizFunnel } from './components/QuizFunnel';

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<QuizFunnel />} />
          <Route path="*" element={<QuizFunnel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
